import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { userApi } from '@atheneum/api'
import PropTypes from 'prop-types'

import Action from '@components/Action'
import Mail from '@components/Icon/Mail'
import Tooltip from '@components/Tooltip/Tooltip'
import { showDialog, isCancellationError } from '@components/Dialog'

class ClientEmailActions extends Component {
  static propTypes = {
    contact: PropTypes.object,
    growlStore: PropTypes.object
  }

  onSendPlatformInvitationEmail = clientId => {
  userApi.sendPlatformInvitationEmail(clientId).then(() => {
      return showDialog({
        title: 'Success',
        text: 'Platform invitation email successfully sent',
        type: 'success'
      }).catch(err => {
        if (isCancellationError(err)) return
        const { growlStore } = this.props
        growlStore.showError(err)
      })
    })
  }

  onResetPassword = clientEmail => {
  userApi.handlePasswordReset(clientEmail).then(() => {
      return showDialog({
        title: 'Success',
        text: 'Password reset link successfully sent',
        type: 'success'
      }).catch(err => {
        if (isCancellationError(err)) return
        const { growlStore } = this.props
        growlStore.showError(err)
      })
    })
  }

  getTooltipMessage = clientEmail => {
    if (!clientEmail) return 'Email is required for this action to take place'
  }

  render () {
    const { contact } = this.props
    return (
      <div className='actions-wrapper'>
        <ul className='actions'>
          {!contact.welcomed && contact.client.knowledgeManager && (
            <li className='action'>
              <Action
                onClick={() => {
                  contact.email &&
                    this.onSendPlatformInvitationEmail(contact.id)
                }}
              >
                <Mail />
                <Tooltip
                  tooltip={this.getTooltipMessage(contact.email)}
                  disabled={contact.email || false}
                >
                  <span>Send platform invitation</span>
                </Tooltip>
              </Action>
            </li>
          )}
          {contact.welcomed && (
            <li className='action'>
              <Action
                onClick={() => {
                  contact.email && this.onResetPassword(contact.email)
                }}
              >
                <Mail />
                <Tooltip
                  tooltip={this.getTooltipMessage(contact.email)}
                  disabled={contact.email || false}
                >
                  <span>Reset password</span>
                </Tooltip>
              </Action>
            </li>
          )}
        </ul>
      </div>
    )
  }
}

export default inject('growlStore')(observer(ClientEmailActions))
